import React, { useState, useEffect } from "react";
import { MdOutlineClose } from "react-icons/md";
import Button from "./Button";
import { useDispatch } from "react-redux";
import { addTodo, updateTodo } from "../slices/todoSlice";
import { v4 as uuid } from "uuid";
import { toast } from "react-hot-toast";
import { AnimatePresence, motion } from "framer-motion";

const dropIn = {
  hidden: {
    opacity: 0,
    transform: "scale(0.9)",
  },
  visible: {
    transform: "scale(1)",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    transform: "scale(0.9)",
    opacity: 0,
  },
};

function TodoModel({ type, modelOpen, setModelOpen, todo }) {
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("incomplete");
  const dispatch = useDispatch();

  useEffect(() => {
    if (type === "update" && todo) {
      setTitle(todo.title);
      setStatus(todo.status);
    } else {
      setTitle("");
      setStatus("incomplete");
    }
  }, [type, todo, modelOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (title === "") {
      toast.error("Please enter a title");
      return;
    }
    if (title && status) {
      if (type === "add") {
        dispatch(
          addTodo({
            id: uuid(),
            title,
            status,
            time: new Date().toLocaleString(),
          })
        );
        toast.success("Task Added Successfully");
      }
      if (type === "update") {
        if (todo.title !== title || todo.status !== status) {
          dispatch(updateTodo({ ...todo, title, status }));
          toast.success("Task Updated successfully");
        } else {
          toast.error("No changes made");
          return;
        }
      }
      setModelOpen(false);
    }
  };

  return (
    <AnimatePresence>
      {modelOpen && (
        <motion.div
          className="flex fixed top-0 left-0 w-[100%] h-[100%] bg-black bg-opacity-50 justify-center items-center z-1000"
          initial={{
            opacity: 0,
          }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-gray-200 max-w-[500px] w-[90%] flex justify-center items-center p-8 rounded-lg relative m-auto border-r-[8px]"
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.div
              className="absolute top-[-10px] right-0 -translate-y-full text-2.5xl px-2 py-1 bg-gray-50 rounded-md bg-gray-1 text-black-2 flex items-center justify-center cursor-pointer transition duration-300 ease-in-out hover:bg-red-500 hover:text-white z-[-1]"
              onClick={() => setModelOpen(false)}
              onKeyDown={() => setModelOpen(false)}
              tabIndex={0}
              role="button"
              initial={{ top: 40, opacity: 0 }}
              animate={{ top: -10, opacity: 1 }}
              exit={{ top: 40, opacity: 0 }}
            >
              <MdOutlineClose />
            </motion.div>
            <form className="w-[100%] " onSubmit={(e) => handleSubmit(e)}>
              <h1 className="text-black text-[2rem] font-semibold mb-[2rem] ">
                {" "}
                {type === "Update" ? "Update" : "Add"} Task
              </h1>
              <label className="font-[1.6rem]" htmlFor="title">
                Title
                <input
                  className="mt-2 mb-8 w-full px-4 py-2 border-none bg-white text-base"
                  type="text"
                  id="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </label>
              <label className="font-[1.6rem]" htmlFor="status">
                Status
                <select
                  id="type"
                  className="mt-2 mb-8 w-full px-4 py-2 border-none bg-white text-base"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="incomplete">Incomplete</option>
                  <option value="complete">Complete</option>
                </select>
              </label>
              <div className="flex justify-start items-center mt-[2rem] gap-[1rem]">
                <Button type="submit">
                  {type === "update" ? "Update" : "Add"} Task
                </Button>
                <Button type="button" onClick={() => setModelOpen(false)}>
                  Cancel
                </Button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default TodoModel;
